<template>
    <div>
        <div :class="['parametric', {
            'is-ready': isReady,
            'is-overlay': isFilterOpen
        }]">
            <div class="parametric__head">
                <div class="parametric__title">
                    <h3 class="parametric-title__title">
                        {{ isEstateFlat ? 'Апартаменты' : 'Коммерческая' }}
                    </h3>
                    <p class="parametric-title__label">{{ flats.length }} в продаже</p>
                </div>

                <OpenFilter v-if="isMobile" />
            </div>

            <Filters
                :isFilterOpen="isFilterOpen"
                ref="filter"
                v-on:close="isFilterOpen = false"
                @openModal="openGenplan"
            />
            <Results />
        </div>
        <GenplanPopup ref="genplanModal"
        @sendBuilding="buildingSelect"></GenplanPopup>

        <DetailPopup ref="detailPopup" @closed="detailPopupClosed" />
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import DetailPopup from './DetailPopup/DetailPopup.vue';
import Filters from './Filters/Filters.vue';
import GenplanPopup from './Genplan-popup/GenplanPopup.vue';
import Observer from 'common/scripts/observer';
import OpenFilter from './OpenFilter/OpenFilter.vue';
import Results from './Results/Results.vue';
import Utils from 'common/scripts/utils';

const observer = new Observer();
const header = document.querySelector('.j-header');
const upButton = document.querySelector('.j-up-button');


export default {
    data: () => {
        return {
            isFilterOpen: false,
            windowWidth : Utils.getWindowWidth()
        };
    },

    components: {
        DetailPopup,
        Filters,
        GenplanPopup,
        OpenFilter,
        Results
    },

    computed: {
        ...mapGetters({
            isReady   : 'GET_IS_READY',
            flats     : 'GET_FLATS',
            estateType: 'GET_ESTATETYPE',
            isMobile  : 'GET_IS_MOBILE'
        }),

        isEstateFlat() {
            return this.estateType === 1;
        }
    },

    created() {
        this.setIsMobile(this.windowWidth < 1280);
    },

    mounted() {
        const body = {type: 'init'};

        this.initApp(body);
        this._bindEvents();

        observer.subscribe('openFilter', () => {
            this.openFilter();
        });

        this.$root.$on('zoom', (flat) => {
            this.$refs.detailPopup.openModal(flat);

            this._toggleClasses(true);

            Utils.bodyFixed();
        });
    },

    watch: {
        windowWidth() {
            this.setIsMobile(this.windowWidth < 1280);
        }
    },

    beforeDestroy() {
        this._unbindEvents();
    },

    methods: {
        ...mapActions(['initApp', 'setIsMobile']),

        _toggleClasses(state) {
            const method = state ? 'add' : 'remove';

            if (header) {
                header.classList[method]('is-zero');
            }

            if (upButton) {
                upButton.classList[method]('is-zero');
            }
        },

        _bindEvents() {
            ['resize', 'orientationchange'].forEach((event) => {
                window.addEventListener(event, this._onResize.bind(this));
            });
        },

        _unbindEvents() {
            ['resize', 'orientationchange'].forEach((event) => {
                window.removeEventListener(event, this._onResize, false);
            });
        },

        openGenplan() {
            this.$refs.genplanModal.openModal();
        },

        buildingSelect() {
            this.$refs.filter.change();
        },
        openFilter() {
            this.isFilterOpen = true;
        },

        _onResize() {
            this.windowWidth = Utils.getWindowWidth();
        },

        detailPopupClosed() {
            Utils.bodyStatic();

            this._toggleClasses(false);
        }
    }
};
</script>
